export default __webpack_public_path__ + "static/media/insights-empty-breakdown-grayscale.67a22815.svg";